
class StandingModel{
   
  constructor (payload) {
      const { records  = {}} = payload;
      this.data = records;
      this.parseData(records);
  } 

  parseData (records) {
    const temp = {};
   
    for (let i = 0; i < records.length; i++) {
       const record = records[i];
       const { league, teamRecords, division: {
        nameShort
       } } = record;
       const leagueId = league?.id;
       if (!temp[leagueId]) {
        temp[leagueId] = {};
       }

       teamRecords.forEach((teamRecord) => {
        const { divisionRank, team: {
          id
        } } = teamRecord;
       
        if (!temp[leagueId][id]) {
          temp[leagueId][id] = {};
        }

        temp[leagueId][id].divisionRank = divisionRank;
        temp[leagueId][id].nameShort = nameShort;
       
      });
    }
    
    this.dataByTeams = temp;
  }  
}
  
export default StandingModel;